import React from 'react';
import numeral from 'numeral';//we use it to format numbers in a certain way
import { Circle,Popup } from "react-leaflet";


const casesTypeColors ={
    //casesTypeColor is an data object with the color for the circles and their radius
    cases: {
        hex:"#CC1034",
        multiplier:300,
    },
    recovered: {
        
        hex:"#7dd71d",
        multiplier:500,
    },
    deaths: {
        hex:"#fb4443", //COLOR OF CIRCLES
        multiplier:2000, //Radius of circles
    },
}

export const sortData = (data) => {
    const sortedData = [...data];

    return sortedData.sort((a,b) => (a.cases > b.cases ? -1 : 1)) ;
}
//draw circles on the map with interactive tool tips
export  const showDataOnMap = (data, casesType = "cases") => 
    
    
    data.map(country => (

        <Circle
            center = {[country.countryInfo.lat, country.countryInfo.long]}
            fillOpacity = {0.4} //transparency of the circles
            color = {casesTypeColors[casesType].hex}
            fillColor = {casesTypeColors[casesType].hex}
            radius = {Math.sqrt(country[casesType])* casesTypeColors[casesType].multiplier}
            >
                <Popup>
                    <div className='info__container'>
                        <div 
                            className ='info__flag'
                            style = {{backgroundImage: `URL(${country.countryInfo.flag})`}}
                        />

                        <div className = 'info__name'>{country.country}</div>

                        <div className = 'info__confirmed'>cases: {numeral(country.cases).format('0,0')}</div>
                        <div className = 'info__recovered'>recovered: {numeral(country.recovered).format(0,0)}</div>
                        <div className = 'info__deaths'>deaths: {numeral(country.deaths).format(0,0)}</div>
                    </div>
                </Popup>
        </Circle>
       ))  
;

export const prettyPrintStat = (stat) => //prettyPrintStat helps in formatting our data
(
    stat?`+${numeral(stat).format('0.0a')}`:'0'
)